module.exports = __webpack_public_path__ + "img/city (1).4611ac7a.png";